module.exports = __webpack_public_path__ + "img/gold.2a7f60f6.png";